import { Integration } from "@/types/general";
import { cn } from "@helpers/utils";
import BaseCollapse from "@reusables/BaseCollapse";
import BaseMaterialCheckbox from "@reusables/BaseMaterialCheckbox";
import ImportEntityHistoryBadge from "./shared/ImportEntityHistoryBadge";
import { isPreviouslyImported } from "./shared/importHistory";

interface SelectableImportCategoryProps {
    text: string;
    icon: JSX.Element;
    isSelected: boolean;
    onChange: (value: boolean) => void;
    history?: Integration.Import.HistoryItem;
    children?: JSX.Element;
}

export default function SelectableImportCategory(props: SelectableImportCategoryProps) {
    const hasImportHistory = isPreviouslyImported(props.history);

    return (
        <BaseCollapse
            isOpen={props.isSelected}
            onOpenChange={props.onChange}
            className={cn(
                props.isSelected &&
                    hasImportHistory &&
                    "border-[#F2B84B] bg-[#FFFDF7] hover:border-[#F2B84B]"
            )}
        >
            <BaseCollapse.Header className="flex flex-row items-center justify-between space-x-2">
                <div>{props.icon}</div>
                <div className="grow min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                        <span>{props.text}</span>
                        <ImportEntityHistoryBadge history={props.history} />
                    </div>
                </div>
                <div className="shrink-0 text-right">
                    <BaseMaterialCheckbox
                        checked={props.isSelected}
                        onChange={(e, v) => props.onChange(v)}
                        checkedClassName="bg-purple-500"
                    />
                </div>
            </BaseCollapse.Header>
            {props.children && <BaseCollapse.Body>{props.children}</BaseCollapse.Body>}
        </BaseCollapse>
    );
}
